import { render, staticRenderFns } from "./FloatingControls.vue?vue&type=template&id=feb0c328&scoped=true&"
import script from "./FloatingControls.vue?vue&type=script&lang=js&"
export * from "./FloatingControls.vue?vue&type=script&lang=js&"
import style0 from "./FloatingControls.vue?vue&type=style&index=0&id=feb0c328&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb0c328",
  null
  
)

component.options.__file = "FloatingControls.vue"
export default component.exports